// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';
//
const wysiwygContent=new BaseModule();
wysiwygContent.name='wysiwyg-content';
wysiwygContent.init();
